export { default } from "./ErrorMessage.jsx";
